import React, { useState } from 'react';
import './App.css';
import HomePage from './HomePage';
import Navbar from './Navbar';
import CarouselBanner from './CarouselBanner';
import SloganGrid from './SloganGrid';
import HowItWorks from './HowItWorks';
import FaqAccordion from './FaqAccordion';
import ContactForm from './ContactForm';
function App() {
  const [visibleSection, setVisibleSection] = useState('home'); // 'home' | 'how' | 'faq'

  return (
    <>
      <Navbar
        onHowClick={() => setVisibleSection('how')}
        onHomeClick={() => setVisibleSection('home')}
        onFaqClick={() => setVisibleSection('faq')}
        onContactClick={() => setVisibleSection('contact')}
      />

      {visibleSection === 'home' && (
        <>
          <CarouselBanner />
          <SloganGrid />
        </>
      )}
      {visibleSection === 'contact' && <ContactForm />}
      {visibleSection === 'how' && <HowItWorks />}
      {visibleSection === 'faq' && <FaqAccordion />}
    </>
  );
}

export default App;